module.exports = __webpack_public_path__ + "img/af_logo_dark.d18c5e1f.svg";